const ITEMS = Array(8).fill("TOKO KAYU MURAH");

export const Marquee = () => (
  <div
    data-testid="keyword-marquee"
    className="overflow-hidden border-y py-5"
    style={{
      backgroundColor: "var(--t-dark)",
      borderColor: "color-mix(in srgb, var(--t-accent) 22%, transparent)",
    }}
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-serif text-lg italic tracking-wide sm:text-xl" style={{ color: "var(--t-accent)" }}>
                {item}
              </span>
              <span className="mx-8 text-white/25">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
